import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import PlusIcon from "../../../../../assets/icons/PlusIcon";
import Spinner from "../../../../../assets/icons/Spinner";
import label from "../../../../../i18n/label";
import Message from "../../../../../i18n/Message";
import ModalDialog from "../../../../shared/ModalDialog";
import backend from "../../../../../backend/backend";
import Notify from "../../../../shared/Notify";

import "./CreateFolderDialog.scss";

const CreateFolderDialog = ({
  workspaceId,
  kbaseId,
  folderId,
  onClose,
  onSuccess,
}) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [formElem, setFormElem] = useState(null);
  const [nameInput, setNameInput] = useState(null);

  useEffect(() => {
    if (nameInput) nameInput.focus();
  }, [nameInput]);

  useEffect(() => {
    // Clear error when name changes
    if (error) {
      setError("");
    }
  }, [name]);

  const onCreate = () => {
    const valid = nameInput.checkValidity();
    if (formElem) formElem.reportValidity();
    if (!valid) return;

    setLoading(true);
    setError("");

    backend
      .createKBAsset(workspaceId, kbaseId, {
        name,
        assetType: "FOLDER",
        folderId,
      })
      .then((resp) => {
        console.log("Created folder ", resp);
        setLoading(false);
        onClose();
        onSuccess && onSuccess();
      })
      .catch(async (err) => {
        console.error("Folder creation failed ", err.json, err);
        if (err.json) {
          const errorJson = await err.json();
          const errorMsg = errorJson?.message
            ? label(intl, errorJson.message)
            : label(intl, "error_creating_folder");
          setError(errorMsg);
        } else {
          setError(label(intl, "error_creating_folder"));
        }
        setLoading(false);
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    onCreate();
  };

  return (
    <ModalDialog onClose={onClose} className="create_folder_dialog">
      <div className="modal_title">
        <Message id={"create_folder_title"} />
      </div>
      <form onSubmit={onSubmit} ref={(val) => setFormElem(val)}>
        <div className="dialog_body">
          <input
            className={`form-control ${error ? "is-invalid" : ""}`}
            type="text"
            ref={(val) => setNameInput(val)}
            required
            maxLength="120"
            placeholder={label(intl, "folder_name_placeholder")}
            onChange={(e) => setName(e.target.value)}
            value={name}
            readOnly={loading}
          />
          {error && <div className="error_message">{error}</div>}
        </div>

        <div className="buttons">
          <button
            className="btn bg-gradient-dark"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <Spinner size="18" />
            ) : (
              <PlusIcon color="#fff" strokeWidth="2" size="18" />
            )}
            <Message id={"create_folder_button"} />
          </button>
          <button className="btn no-btn" onClick={onClose}>
            <Message id="cancel" />
          </button>
        </div>
      </form>
    </ModalDialog>
  );
};

export default CreateFolderDialog;
